<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg723"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs727"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath737"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path735" /></clipPath></defs><g
     id="g729"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g731"><g
         id="g733"
         clip-path="url(#clipPath737)"><g
           id="g739"
           transform="translate(287.7642,447.8335)"><path
             d="m 0,0 h -15.333 v 15.304 c 0,5.236 -4.281,9.518 -9.488,9.518 h -13.886 c -5.236,0 -9.518,-4.282 -9.518,-9.518 V 0 h -15.303 c -5.236,0 -9.518,-4.282 -9.518,-9.518 v -13.857 c 0,-5.237 4.282,-9.519 9.518,-9.519 h 15.303 v -15.332 c 0,-5.236 4.282,-9.518 9.518,-9.518 h 13.886 c 5.207,0 9.488,4.282 9.488,9.518 v 15.332 H 0 c 5.236,0 9.518,4.282 9.518,9.519 V -9.518 C 9.518,-4.282 5.236,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path741" /></g><g
           id="g743"
           transform="translate(504.5,279.5488)"><path
             d="M 0,0 H -106.256"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path745" /></g><g
           id="g747"
           transform="translate(7.5,279.5488)"><path
             d="M 0,0 H 106.256"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path749" /></g><g
           id="g751"
           transform="translate(289.2393,79.1235)"><path
             d="M 0,0 V -20.222"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path753" /></g><g
           id="g755"
           transform="translate(222.7314,78.9785)"><path
             d="M 0,0 V -20.193"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path757" /></g><g
           id="g759"
           transform="translate(429.7764,180.8984)"><path
             d="M 0,0 H 43.191"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path761" /></g><g
           id="g763"
           transform="translate(429.7764,131.5732)"><path
             d="M 0,0 H 43.191"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path765" /></g><g
           id="g767"
           transform="translate(429.7764,82.248)"><path
             d="M 0,0 H 43.191"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path769" /></g><g
           id="g771"
           transform="translate(429.7764,230.2236)"><path
             d="M 0,0 H 43.191"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path773" /></g><g
           id="g775"
           transform="translate(82.2236,180.8984)"><path
             d="M 0,0 H -43.191"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path777" /></g><g
           id="g779"
           transform="translate(82.2236,131.5732)"><path
             d="M 0,0 H -43.191"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path781" /></g><g
           id="g783"
           transform="translate(82.2236,82.248)"><path
             d="M 0,0 H -43.191"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path785" /></g><g
           id="g787"
           transform="translate(82.2236,230.2236)"><path
             d="M 0,0 H -43.191"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path789" /></g><g
           id="g791"
           transform="translate(168.75,312.4419)"><path
             d="m 0,0 h 34.715 c 1.736,0 3.182,-1.446 3.182,-3.182 v -31.534 c 0,-1.736 -1.446,-3.182 -3.182,-3.182 H 0 c -1.735,0 -3.153,1.446 -3.153,3.182 V -3.182 C -3.153,-1.446 -1.735,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path793" /></g><g
           id="g795"
           transform="translate(238.6426,312.4419)"><path
             d="m 0,0 h 34.715 c 1.736,0 3.153,-1.446 3.153,-3.182 v -31.534 c 0,-1.736 -1.417,-3.182 -3.153,-3.182 H 0 c -1.736,0 -3.182,1.446 -3.182,3.182 V -3.182 C -3.182,-1.446 -1.736,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path797" /></g><g
           id="g799"
           transform="translate(308.5352,312.4419)"><path
             d="m 0,0 h 34.686 c 1.764,0 3.182,-1.446 3.182,-3.182 v -31.534 c 0,-1.736 -1.418,-3.182 -3.182,-3.182 H 0 c -1.765,0 -3.182,1.446 -3.182,3.182 V -3.182 C -3.182,-1.446 -1.765,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path801" /></g><g
           id="g803"
           transform="translate(168.75,243.7051)"><path
             d="m 0,0 h 34.715 c 1.736,0 3.182,-1.418 3.182,-3.183 v -31.533 c 0,-1.736 -1.446,-3.153 -3.182,-3.153 H 0 c -1.735,0 -3.153,1.417 -3.153,3.153 V -3.183 C -3.153,-1.418 -1.735,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path805" /></g><g
           id="g807"
           transform="translate(238.6426,243.7051)"><path
             d="m 0,0 h 34.715 c 1.736,0 3.153,-1.418 3.153,-3.183 v -31.533 c 0,-1.736 -1.417,-3.153 -3.153,-3.153 H 0 c -1.736,0 -3.182,1.417 -3.182,3.153 V -3.183 C -3.182,-1.418 -1.736,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path809" /></g><g
           id="g811"
           transform="translate(308.5352,243.7051)"><path
             d="m 0,0 h 34.686 c 1.764,0 3.182,-1.418 3.182,-3.183 v -31.533 c 0,-1.736 -1.418,-3.153 -3.182,-3.153 H 0 c -1.765,0 -3.182,1.417 -3.182,3.153 V -3.183 C -3.182,-1.418 -1.765,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path813" /></g><g
           id="g815"
           transform="translate(177.1685,9.2002)"><path
             d="m 0,0 h 157.634 v 122.778 c 0,3.847 -3.298,7.001 -7.348,7.001 H 7.377 C 3.327,129.779 0,126.625 0,122.778 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path817" /></g><g
           id="g819"
           transform="translate(256,128.5645)"><path
             d="M 0,0 V -119.364"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path821" /></g><g
           id="g823"
           transform="translate(113.7563,167.5908)"><path
             d="m 0,0 v 192.354 m 284.487,0 V -158.391 H 0 v 123.038"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path825" /></g><g
           id="g827"
           transform="translate(398.2437,323.5801)"><path
             d="m 0,0 h 100.615 c 3.095,0 5.641,-2.546 5.641,-5.67 V -314.38 H 0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path829" /></g><g
           id="g831"
           transform="translate(113.7563,323.5801)"><path
             d="m 0,0 h -100.615 c -3.125,0 -5.641,-2.546 -5.641,-5.67 V -314.38 H 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path833" /></g><g
           id="g835"
           transform="translate(340.5015,359.9448)"><path
             d="m 0,0 v 137.85 c 0,2.749 -2.256,5.005 -5.034,5.005 h -158.965 c -2.748,0 -5.004,-2.256 -5.004,-5.005 V 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path837" /></g><g
           id="g839"
           transform="translate(278.1597,359.9448)"><path
             d="m 0,0 h 130.325 c 3.616,0 6.567,2.951 6.567,6.567 v 33.732 c 0,3.616 -2.951,6.567 -6.567,6.567 H 62.342 m -169.003,0 h -67.984 c -3.615,0 -6.595,-2.951 -6.595,-6.567 V 6.567 c 0,-3.616 2.98,-6.567 6.595,-6.567 h 139.323"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path841" /></g></g></g></g></svg>
</template>
